import { render, staticRenderFns } from "./FormularioList.vue?vue&type=template&id=24261878&scoped=true"
import script from "./FormularioList.vue?vue&type=script&lang=js"
export * from "./FormularioList.vue?vue&type=script&lang=js"
import style0 from "./FormularioList.vue?vue&type=style&index=0&id=24261878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24261878",
  null
  
)

export default component.exports